import React, {Component} from 'react'
import {colors} from "../../utils/styles"
import {formatNumber} from "../../utils/util"

export class InvoiceAndStatusRenderer extends Component {

  renderInvoiceAndStatus(invRow, key) {
    const invoiceStatusStyle = invRow.status !== 'Settled' ? {color: colors.darkRed} : null
    return (
        <div key={key} style={{display: 'flex'}}>
          <div style={{gridTemplateColumns: '90px 110px 85px 255px', display: 'grid', gridColumnGap: '5px'}}>
            <div>{invRow.invoice}</div>
            <div>{formatNumber(invRow.invoiceAmount) + ' ' + invRow.currency}</div>
            <div style={invoiceStatusStyle}>{invRow.status}</div>
            <div>{invRow.paymentReqNo}</div>
          </div>
        </div>
    )
  }

  render() {
    return (
        <div>
          {this.props.value.map((pair, i) => this.renderInvoiceAndStatus(pair, i))}
        </div>
    )
  }
}

export default InvoiceAndStatusRenderer